import { concat, defer, EMPTY, Observable } from 'rxjs';
import { PollingConfiguration } from './model/polling-configuration';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const extendPollingConfiguration = (configuration: PollingConfiguration) => ({
  withComplete: (complete: () => Observable<unknown>): PollingConfiguration => ({
    ...configuration,
    complete: () =>
      concat(
        defer(() => (configuration.complete ? configuration.complete() : EMPTY)),
        defer(() => complete())
      )
  }),
  withProceed: (proceed: () => Observable<unknown>): PollingConfiguration => ({
    ...configuration,
    proceed: () =>
      concat(
        defer(() => (configuration.proceed ? configuration.proceed() : EMPTY)),
        defer(() => proceed())
      )
  })
});
